/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import type { Listable, Pin, Property } from '@zcode/state-type'
import { isRoomForRent } from './isRoomForRent'

export function getBedsBathsText(
  rentable: Pick<
    Listable | Property | Pin,
    | 'bathrooms'
    | 'bathroomText'
    | 'bathroomTxt'
    | 'bedroomText'
    | 'bedroomTxt'
    | 'feedName'
    | 'maxBathrooms'
    | 'propertyType'
  >,
  mini: true
):
  | ''
  | 'Room'
  | (typeof rentable)['bedroomTxt']
  | `${'Room' | (typeof rentable)['bedroomTxt']} · ${(typeof rentable)['bedroomTxt']}`
export function getBedsBathsText(
  rentable: Pick<
    Listable | Property | Pin,
    | 'bathrooms'
    | 'bathroomText'
    | 'bathroomTxt'
    | 'bedroomText'
    | 'bedroomTxt'
    | 'feedName'
    | 'maxBathrooms'
    | 'propertyType'
  >,
  mini?: false
):
  | ''
  | 'Room for Rent'
  | (typeof rentable)['bedroomText']
  | `${'Room for Rent' | (typeof rentable)['bedroomText']} · ${(typeof rentable)['bedroomText']}`
export function getBedsBathsText(
  rentable: Pick<
    Listable | Property | Pin,
    | 'bathrooms'
    | 'bathroomText'
    | 'bathroomTxt'
    | 'bedroomText'
    | 'bedroomTxt'
    | 'feedName'
    | 'maxBathrooms'
    | 'propertyType'
  >,
  mini?: boolean
):
  | ''
  | 'Room'
  | 'Room for Rent'
  | (typeof rentable)['bedroomText' | 'bedroomTxt']
  | `${
      | 'Room'
      | 'Room for Rent'
      | (typeof rentable)['bedroomText' | 'bedroomTxt']} · ${(typeof rentable)[
      | 'bedroomText'
      | 'bedroomTxt']}`
export function getBedsBathsText(
  rentable: Pick<
    Listable | Property | Pin,
    | 'bathrooms'
    | 'bathroomText'
    | 'bathroomTxt'
    | 'bedroomText'
    | 'bedroomTxt'
    | 'feedName'
    | 'maxBathrooms'
    | 'propertyType'
  >,
  mini?: boolean
) {
  const room = isRoomForRent(rentable)
  let txt: '' | 'Room' | 'Room for Rent' | (typeof rentable)['bedroomText' | 'bedroomTxt'] = ''
  if (room) {
    txt = mini ? 'Room' : 'Room for Rent'
  } else if (rentable.bedroomTxt) {
    txt = mini ? rentable.bedroomTxt : rentable.bedroomText
  }
  if (!rentable.bathrooms && !rentable.maxBathrooms) {
    return txt
  }
  if (rentable.bathroomText) {
    const bathroomText = mini ? rentable.bathroomTxt : rentable.bathroomText
    return txt ? `${txt} · ${bathroomText}` : bathroomText
  }
  return txt
}
